import React from 'react';
import classnames from 'classnames';
import { ContactItemProps } from '../interfaces';
import { formatSeparatorDate } from "../../utils/date.util";
import { MessageReplyPreview } from '../chatWindow/MediaAttachments';

const ContactItem: React.FC<ContactItemProps> = ({
    contact,
    isSelected,
    onSelect,
    unreadCount = 0
}) => {
    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        onSelect(contact.id);
    };

    const lastUpdated = contact.lastMessageAt;
    const lastMessage = contact.lastMessage;

    return (
        <li className={classnames({ active: isSelected })}>
            <a href="#" onClick={handleClick}>
                <div className="d-flex align-items-start position-relative">
                    <div className="flex-shrink-0 align-self-center me-3 position-relative">

                        <div
                            className="avatar-xs d-flex align-items-center justify-content-center bg-light rounded-circle text-primary"
                            style={{ width: '32px', height: '32px' }}
                        >
                            <i className="ri-user-3-line fs-14"></i>
                        </div>

                        {unreadCount > 0 && (
                            <span
                                className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                                style={{ fontSize: '9px', minWidth: '14px', minHeight: '14px' }}
                            >
                                {unreadCount}
                            </span>
                        )}

                    </div>
                    <div className="flex-grow-1 overflow-hidden">
                        <p
                            className="text-truncate mb-1 fs-14 fw-medium"
                            style={{ paddingRight: '70px' }}
                        >
                            {`${contact?.customer?.firstName ?? ''} ${contact?.customer?.lastName ?? ''}` || contact?.name}
                            {contact.isVerified && (
                                <i className="ri-checkbox-circle-fill text-success ms-1 fs-12"></i>
                            )}
                        </p>
                        <div className="text-muted fs-12 mb-0" style={{
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            whiteSpace: 'normal',
                            minHeight: '2.5rem'
                        }}>
                            {lastMessage ? (
                                <div className="d-flex align-items-center justify-content-between w-100 gap-1">
                                    {lastMessage?.direction === 'outbound' && (
                                        <i
                                            className={classnames("fs-14 flex-shrink-0", {
                                                "ri-check-line": lastMessage?.status === "sent",
                                                "ri-check-double-line": lastMessage?.status === "delivered",
                                                "ri-check-double-line text-info":
                                                    lastMessage?.status === "read" || !lastMessage?.status
                                            })}
                                        ></i>
                                    )}
                                    <div
                                        className="text-truncate position-relative"
                                        style={{ flex: 1, minWidth: 0, paddingRight: '0px' }}
                                    >
                                        <MessageReplyPreview message={lastMessage as any} />
                                    </div>
                                    <p
                                        className="text-muted fs-11 mb-0 position-absolute top-0 end-0"
                                        style={{ right: 0 }}
                                    >
                                        {formatSeparatorDate(lastUpdated)}
                                    </p>
                                </div>
                            ) : (
                                'Sin mensajes'
                            )}
                        </div>
                    </div>
                </div>
            </a>
        </li>
    );
};

export default ContactItem;
